import i18nInvoice from './invoice/i18nInvoice';
import i18nCommon from './common/i18nCommon';
import i18nComponent from './components/i18nComponent';
import i18nDateRange from './i18nDateRange';
import i18nEnum from './i18nEnum';
import i18nNavbar from './layouts/i18nNavbar';
import i18nNotification from './notification/i18nNotification';
import i18nShortkey from './common/i18nShortkey';
import i18nSlidebar from './layouts/i18nSlidebar';
import i18nUserManager from './i18nUserManager';
import i18nValidate from './i18nValidate';
import i18nSystem from './i18nSystem';
import i18nReport from './i18nReport';
import i18nOrganization from './organization/i18nOrganization';
import i18nStarted from './i18nStarted';
import i18nInbox from './inbox/i18nInbox';
import i18nProceduce from './i18nProceduce';
import i18nSupplier from './supplier/i18nSupplier';
import i18nResource from './system/i18nResource';
import i18nAuditingLog from './system/i18nAuditingLog';
import i18nNetPromoterScore from './system/i18nNetPromoterScore';
import i18nDashboard from './dashboard/i18nDashboard';
import i18nSetting from './system/i18nSettingSystem';
import i18nClassifitionInvoice from './system/i18nClassifitionInvoice';
import i18nRole from './system/i18nRole';
import i18nConnectInvoice from './connectInvoice/i18nConnectInvoice.js';
import i18nOutInvoice from './outInvoice/i18nOutInvoice';
import i18nLayout from './layouts/i18nLayout';
import i18nCustomsDeclaration from './customsdeclaration/i18nCustomsDeclaration';
import i18nColumnExport from './columnExport/i18nColumnExport';
import i18nUserSetup from './system/i18nUserSetup';
import i18nAnalysisAI from './i18nAnalysisAI';
import i18nTooltip from './tooltip/i18nTooltip';
import i18nConnectSupplier from './connectSupplier/i18nConnectSupplier';
import i18nConnectTaxaxion from './connectTaxaxion/i18nConnectTaxaxion';

export default {
    i18nInvoice,
    i18nCommon,
    i18nComponent,
    i18nDateRange,
    i18nEnum,
    i18nNavbar,
    i18nNotification,
    i18nShortkey,
    i18nSlidebar,
    i18nUserManager,
    i18nValidate,
    i18nSystem,
    i18nReport,
    i18nOrganization,
    i18nStarted,
    i18nInbox,
    i18nProceduce,
    i18nSupplier,
    i18nResource,
    i18nAuditingLog,
    i18nNetPromoterScore,
    i18nDashboard,
    i18nSetting,
    i18nClassifitionInvoice,
    i18nRole,
    i18nConnectInvoice,
    i18nOutInvoice,
    i18nLayout,
    i18nCustomsDeclaration,
    i18nColumnExport,
    i18nUserSetup,
    i18nAnalysisAI,
    i18nTooltip,
    i18nConnectSupplier,
    i18nConnectTaxaxion
};
